import { Button } from "@/components/ui/button";
import { FileText } from "lucide-react";

interface DocumentsButtonProps {
  onClick: () => void;
}

export const DocumentsButton = ({ onClick }: DocumentsButtonProps) => (
  <Button variant="ghost" size="icon" onClick={onClick}>
    <FileText className="h-4 w-4" />
  </Button>
);